export const SYNC_PERSISTED_RECORDING = 'SYNC_PERSISTED_RECORDING';

export const SAVE_RESULT_TO_STORAGE = 'SAVE_RESULT_TO_STORAGE';

export const REMOVE_RESULT_FROM_STORAGE = 'REMOVE_RESULT_FROM_STORAGE';

export const SAVE_CONTENT_TO_STORAGE = 'SAVE_CONTENT_TO_STORAGE';

export const syncPersistedRecording = (resultId, shouldRetry = false) => ({
    type: SYNC_PERSISTED_RECORDING,
    resultId,
    shouldRetry,
});

export const saveResultToStorage = (studentUid, measure, postData) => async dispatch =>
    dispatch({
        type: SAVE_RESULT_TO_STORAGE,
        studentUid,
        measure,
        postData,
    });

export const removeResultFromStorage = (studentUid, measure) => async dispatch =>
    dispatch({
        type: REMOVE_RESULT_FROM_STORAGE,
        studentUid,
        measure,
    });

export const saveContentToStorage = (endpoint, data) => ({
    type: SAVE_CONTENT_TO_STORAGE,
    endpoint,
    data,
});
